module["exports"] = [];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sk/address/state.js
 ** module id = 939
 ** module chunks = 0
 **/